import { Hero } from "@/components/sections/Hero";
import { PersonalStory } from "@/components/sections/PersonalStory";
import { TimelineSection } from "@/components/sections/TimelineSection";
import { YoutubeSection } from "@/components/sections/YoutubeSection";
import { FishRoomSection } from "@/components/sections/FishRoomSection";
import { BreedingSection } from "@/components/sections/BreedingSection";
import { BusinessSection } from "@/components/sections/BusinessSection";
import { CommunitySection } from "@/components/sections/CommunitySection";
import { TestLabSection } from "@/components/sections/TestLabSection";
import { RecentWinnersSection } from "@/components/sections/RecentWinnersSection";
import { useSiteSettings } from "@/context/SiteSettingsContext";

export default function Home() {
  const { isEnabled } = useSiteSettings();
  return (
    <>
      <Hero />
      <PersonalStory />
      {isEnabled("journey") && <TimelineSection />}
      {isEnabled("youtube") && <YoutubeSection />}
      {isEnabled("fish_room") && <FishRoomSection />}
      {isEnabled("breeding") && <BreedingSection />}
      {isEnabled("business") && <BusinessSection />}
      {isEnabled("community") && <CommunitySection />}
      {isEnabled("recent_winners") && <RecentWinnersSection />}
      {isEnabled("test_lab") && <TestLabSection />}
    </>
  );
}
